<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-2/3 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:flex lg:w-1/2 px-4 py-10 color-bg-login min-h-login flex-col justify-center items-center">
              <img class="mb-5 max-w-logo block mx-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">
              <img src="@/assets/images/pages/workspace.svg" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container py-login">

                <div class="vx-row vx-card__title mb-4">
                  <img class="block lg:hidden mb-5 max-w-logo mx-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">

                  <div class="vx-col md:w-full justify-center items-center">
                    <h2 class="mb-4">¡Queremos conocerte!</h2>
                  </div>

                  <!-- ¿Cómo usarás Verificamex? -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs d-block">¿Cómo usarás Verificamex?</label>
                    <v-select
                      v-model="selectUsoDigitaFirma"
                      :options="usoDigitaFirmaOptions"
                      :reduce="option => option.value"
                      :searchable="false"
                      class="select-large mt-3 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cómo te identificas? -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs d-block">¿Cómo te identificas?</label>
                    <v-select
                      v-model="selectTipoPersona"
                      :options="tipoPersonaOptions"
                      :reduce="option => option.value"
                      :searchable="false"
                      class="select-large mt-3 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cuál es tu sector? -->
                  <div class="vx-col w-full">
                    <label class="text-sm label-vs mt-3 block">¿Cuál es tu sector?</label>
                    <v-select
                      v-model="selectSector"
                      :options="sectorOptions"
                      :searchable="false"
                      class="questions-select mt-3 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- Tamaño de tu empresa -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs mt-3 block">Tamaño de tu empresa</label>
                    <v-select
                      v-model="selectCantidadEmpleados"
                      :options="cantidadEmpleadosOptions"
                      :reduce="option => option.value"
                      :searchable="false"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cómo quieres firmar? -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs block mt-3">¿Cómo quieres firmar?</label>
                    <v-select
                      v-model="selectTipoFirma"
                      :options="tipoFirmaOptions"
                      :reduce="option => option.value"
                      :searchable="false"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cuánto firmas al mes? -->
                  <div class="vx-col w-1/2">
                    <label class="text-sm label-vs block mt-3">¿Cuánto firmas al mes?</label>
                    <v-select
                      v-model="selectCantidadFirmas"
                      :options="cantidadFirmasOptions"
                      :reduce="option => option.value"
                      :searchable="false"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Cómo se enteró de nosotros? -->
                                    <div class="vx-col w-1/2">
                    <label class="text-sm label-vs block mt-3">¿Cómo se enteró de nosotros?</label>
                    <v-select
                      v-model="selectComoSeEntero"
                      :options="comoSeEnteroOptions"
                      :reduce="option => option.value"
                      :searchable="false"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Te gustaría que un especialista te contacte? -->
                  <div class="vx-col w-full">
                    <label class="text-sm label-vs block mt-3">¿Te gustaría que un especialista te contacte?</label>
                    <v-select
                      v-model="selectContacto"
                      :options="contactoOptions"
                      :reduce="option => option.value"
                      :searchable="false"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- ¿Por qué medio te gustaría que te contactemos? -->
                  <div class="vx-col w-full" v-if="selectContacto === 'yes'">
                    <label class="text-sm label-vs block mt-3">¿Por qué medio te gustaría que te contactemos?</label>
                    <v-select
                      v-model="selectMedioContacto"
                      :options="medioContactoOptions"
                      :reduce="option => option.value"
                      :searchable="false"
                      class="select-large mt-2 w-full"
                      placeholder="Selecciona una opción"
                    ></v-select>
                  </div>

                  <!-- Botón Siguiente -->
                  <div class="vx-col mt-3 w-full">
                    <vs-button :disabled="isSubmitting" id="button-with-loading" class="float-right mt-4" @click="storeQuestions">Siguiente</vs-button>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </vx-card>
    </div>
    <vs-popup class="holamundo" title="Agendar Demo" :active.sync="showHubspotModal" @close="clearHubspotEmbed">
      <div ref="hubspotContainer" style="min-height: 500px;"></div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import router from '@/router';

export default {
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      selectUsoDigitaFirma: '',
      usoDigitaFirmaOptions: [
        { value: 'api', label: 'Quiero firmar vía API' },
        { value: 'plataforma', label: 'Usaré la plataforma Web' },
      ],
      selectTipoPersona: '',
      tipoPersonaOptions: [
        { value: 'Persona física', label: 'Persona física' },
        { value: 'Persona Moral (Empresa)', label: 'Persona Moral (Empresa)' },
      ],
      selectSector: '',
      sectorOptions: [
        'Banca y Seguros',
        'Bienes Raíces y Construcción',
        'Consultoría y Servicios Profesionales',
        'Educación y Certificaciones',
        'E-commerce y Marketplaces',
        'Fintech y Pagos Digitales',
        'Gobierno y Sector Público',
        'Legal y Notarías',
        'Logística y Transporte',
        'Plataformas de Crédito y Préstamos',
        'PropTech (Tecnología Inmobiliaria)',
        'Publicidad y Marketing',
        'Recursos Humanos y Reclutamiento',
        'Salud Digital y Telemedicina',
        'SaaS (Software como Servicio)',
        'Seguridad Privada y Vigilancia',
        'Soy Freelance',
        'Soy Estudiante',
        'Otro'
      ],
      selectCantidadEmpleados: '',
      cantidadEmpleadosOptions: [
        { value: 'Solo yo', label: 'Solo yo' },
        { value: '1-10', label: '1-10' },
        { value: '11-50', label: '11-50' },
        { value: '51-100', label: '51-100' },
        { value: 'Más de 100', label: 'Más de 100' },
      ],
      selectTipoFirma: '',
      tipoFirmaOptions: [
        { value: 'FirmaBiometricos', label: 'Firma con INE (Identidad)' },
        { value: 'FirmaSimple', label: 'Firma Simple con video' },
        { value: 'eFirmaSAT', label: 'Firma con e.firma (SAT)' },
        { value: 'FirmaElectronicaFIREL', label: 'Firma con FIREL (PJF)' },
        { value: 'TodasLasAnteriores', label: 'Quiero todas las anteriores' },
      ],
      selectCantidadFirmas: '',
      cantidadFirmasOptions: [
        { value: '1-10', label: '1-10' },
        { value: '10-50', label: '10-50' },
        { value: '50-100', label: '50-100' },
        { value: '100-1000', label: '100-1,000' },
        { value: 'Mas de 1000', label: 'Más de 1,000' },
      ],
      selectComoSeEntero: '',
      comoSeEnteroOptions: [
        { value: 'Google', label: 'Google' },
        { value: 'Bing', label: 'Bing' },
        { value: 'AnuncioFacebook', label: 'Anuncio en Facebook' },
        { value: 'AnuncioInstagram', label: 'Anuncio en Instagram' },
        { value: 'RecomendacionAmigo', label: 'Recomendación de un amigo' },
        { value: 'Tiktok', label: 'Tiktok' },
        { value: 'Podcast', label: 'Podcast' },
        { value: 'LeiUnBlog', label: 'Leí un blog' },
        { value: 'YouTube', label: 'YouTube' },
        { value: 'Otro', label: 'Otro' },
      ],
      selectContacto: '',
      contactoOptions: [
        { value: 'no', label: 'No' },
        { value: 'yes', label: 'Sí' },
      ],
      selectMedioContacto: '',
      medioContactoOptions: [
        { value: 'call', label: 'Llamada' },
        { value: 'whatsapp', label: 'WhatsApp' },
        { value: 'email', label: 'Correo' },
        { value: 'schedule_demo', label: 'Me gustaría agendar una demo ahora' },
      ],
      showHubspotModal: false,
      isSubmitting: false,
    };
  },
  watch: {
    selectContacto(newValue) {
      if (newValue === 'no') {
        this.selectMedioContacto = '';
      }
    },
    selectMedioContacto(newValue) {
      if (newValue === 'schedule_demo') {
        this.showHubspotModal = true;
      }
    },
    showHubspotModal(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.injectHubspotEmbed();
        });
      }
    }
  },
  methods: {
    injectHubspotEmbed() {
      const container = this.$refs.hubspotContainer;
      if (!container) return;

      container.innerHTML = ''; // Clear previous content

      const mexicoCityTime = new Date().toLocaleString("en-US", { timeZone: "America/Mexico_City" });
      const hour = new Date(mexicoCityTime).getHours();
      let baseUrl;
      if (hour < 13) {
        baseUrl = 'https://meetings.hubspot.com/danytza?embed=true';
      } else {
        baseUrl = 'https://meetings.hubspot.com/mariam-sanchez?embed=true';
      }

      let finalUrl = baseUrl;
      const user = this.$store.state.account.user;
      if (user && user.me) {
        try {
          const me = user.me;
          const email = me.email;
          const firstName = me.name ? me.name.split(' ')[0] : '';
          const lastName = me.last_name || '';

          const params = new URLSearchParams();
          if (firstName) params.append('firstname', firstName);
          if (lastName) params.append('lastname', lastName);
          if (email) params.append('email', email);

          const queryString = params.toString();
          if (queryString) {
            finalUrl = `${baseUrl}&${queryString}`;
          }
        } catch (e) {
          console.error("Error processing user data from store", e);
        }
      }

      const hubspotDiv = document.createElement('div');
      hubspotDiv.className = 'meetings-iframe-container';
      hubspotDiv.dataset.src = finalUrl;
      container.appendChild(hubspotDiv);

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
      container.appendChild(script);
    },
    clearHubspotEmbed() {
      const container = this.$refs.hubspotContainer;
      if (container) {
        container.innerHTML = '';
      }
    },
    getQuestionPending() {
      let values = {
        '¿Cómo usarás Verificamex?': this.selectUsoDigitaFirma,
        '¿Cómo te identificas?': this.selectTipoPersona,
        '¿Cuál es tu sector?': this.selectSector,
        'Tamaño de tu empresa': this.selectCantidadEmpleados,
        '¿Cómo quieres firmar?': this.selectTipoFirma,
        '¿Cuánto firmas al mes?': this.selectCantidadFirmas,
        '¿Cómo se enteró de nosotros?': this.selectComoSeEntero,
        '¿Te gustaría que un especialista te contacte?': this.selectContacto,
      }
      let question = null;
      Object.keys(values).every((key) => {
        if (!values[key]) {
          question = key;
          return false;
        }
        return true;
      });
      return question;
    },
    storeQuestions() {
      if (
        !this.selectUsoDigitaFirma ||
        !this.selectTipoPersona ||
        !this.selectCantidadEmpleados ||
        !this.selectTipoFirma ||
        !this.selectCantidadFirmas ||
        !this.selectComoSeEntero ||
        !this.selectSector ||
        !this.selectContacto
      ) {
        let question = this.getQuestionPending();
        this.$vs.notify({
          title: 'Error',
          text: 'Por favor ingrese los datos requeridos. El campo "' + question + '" es obligatorio.',
          color: 'danger',
          position: 'bottom-center',
        });
        return;
      }

      if (this.selectContacto === 'yes' && !this.selectMedioContacto) {
        this.$vs.notify({
          title: 'Error',
          text: 'Por favor ingrese los datos requeridos. El campo "¿Por qué medio te gustaría que te contactemos?" es obligatorio.',
          color: 'danger',
          position: 'bottom-center',
        });
        return;
      }

      this.isSubmitting = true;
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#button-with-loading',
        scale: 0.45,
      });

      const contactPreference = this.selectContacto === 'no' ? 'no_contact' : this.selectMedioContacto;

      this.$store
        .dispatch('account/onBoardingQuestions', {
          data: {
            digitafirma_use: this.selectUsoDigitaFirma,
            type_person: this.selectTipoPersona,
            sector: this.selectSector,
            employee_quantity: this.selectCantidadEmpleados,
            type_signature: this.selectTipoFirma,
            signature_quantity: this.selectCantidadFirmas,
            how_to_known: this.selectComoSeEntero,
            contact_preference: contactPreference,
          },
        })
        .then(
          () => {
            this.$store.dispatch('account/me', { aclChangeRole: this.$acl.change }).then(() => {
              this.isSubmitted = false;
              this.$vs.loading.close('#button-with-loading > .con-vs-loading');
              router.push('/');
            });
          },
          (error) => {
            this.isSubmitting = false;
            this.$vs.loading.close('#button-with-loading > .con-vs-loading');
            console.log(error);
          }
        );
    },

  },
  mounted() {
      const email = this.$store.state.account.user.me.email;
      const phone = this.$store.state.account.user.me.phone;
      window.gtag('set', 'user_data', {
          "email": email,
          "phone_number": `+${phone}`
        });
      window.gtag('event', 'conversion', { send_to: 'AW-462309740/pvl6CMHb3dwZEOySudwB' });

      window.gtag('event', 'sign_up', {
          method: '[GA4]_Registro_exitoso',
          "user_id": email,
          "phone_number": `${phone}`/*No es necesario poner el + ya se envia*/
      });

      window.fbq('track', 'CompleteRegistration', {
          content_name: 'Registro_exitoso_Firma',
          status: 'success',
      });

  },
};
</script>

<style scoped>
body {
  max-height: 100vh;
}
.label-vs {
  font-size: 11.9px !important;
  color: rgba(0, 0, 0, 0.6);
}
.questions-select .vs__dropdown-menu {
  max-height: 300px !important;
}
.select-large .vs__dropdown-toggle {
  padding: 0.59px 0 7px 0 !important;
}
.min-h-login {
  height: 500px;
}
</style>
